import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import classNames from "classnames";
import styles from "./game-score.module.scss";

export class GameScoreProps extends BaseProps {}

export const GamePossession = ({competitor, isHomeCompetitor, shouldRenderPossession}: GameScoreProps) => {
  const shouldRenderPossessionArrow: Boolean = shouldRenderPossession && competitor.inPossession;
  const className: String = isHomeCompetitor ? styles.home_arrow : styles.away_arrow

  return (
    shouldRenderPossession ? <div className={classNames(styles.arrow_container)}>
      {
        shouldRenderPossessionArrow ? <div className={classNames(styles.arrow, className)}/> : null
      }
    </div> : null
  )
}
